module.exports = __webpack_public_path__ + "64419a96fc32f1b21badcf6b0788ebaf.pdf";